import React, { useState } from "react";
import Modal from "react-modal";
import "./DiscardReasonModal.css";
import Box from "../PlanReviews/Box";
import Cross from "@safecv/assets/Images/cross.png";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0px",
    width: "480px",
    height: "330px",
    overflow: "hidden",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

Modal.defaultStyles.overlay.backgroundColor = "rgb(0, 0, 0, 0.5)";

const DiscardReasonModal = (props) => {
  const { isModalOpen, handleClose, annotationName, handleDiscardAnnotation, setSelectedAnnotationUuid } = props

  const [textvalue, setTextValue] = useState("");
  const [checkValue,setCheckValue] = useState([
    {
      id: 1,
      label: "Incorrect Location of Annotation",
      isChecked: false,
      Highlight: false,
    },
    {
      id: 2,
      label: "Annotation is not applicable",
      isChecked: false,
      Highlight: false,
    },
    { 
      id: 3,
      label: "None of the above", 
      isChecked: false,
       Highlight: false 
    },
  ]);
  const [selectedValue, setSelectedValue] = useState("");

  const handleTextValueChange = (e) => {
    setTextValue(e.target.value)
  };

  const handleCheckBoxChange = (value, id, label) => {
    let inputs = [...checkValue]
    inputs.forEach((input) => {
      if (input.id === id) {
        if(value) {
          input.isChecked = value;
          input.Highlight = value;
          setSelectedValue(label)
          setCheckValue(inputs)
          return;
        }
      } else {
        input.isChecked = false;
        input.Highlight = false;
      }
    });
  };

  const handleClear = () => {
    let clonedCheckValue = [...checkValue]
    clonedCheckValue.forEach( (list) => {
      list.isChecked = false;
      list.Highlight = false;
    })
    setTextValue("")
    setSelectedValue("")
    setCheckValue(clonedCheckValue)
  }

  const handleCloseModal = () => {
    handleClear()
    handleClose()
  };

  const handleDiscard = (textvalue, selectedValue) => {
    handleDiscardAnnotation(textvalue, selectedValue)
    setTimeout(handleClear,100)
  }

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        style={customModalStyles}
        contentLabel="Discard Modal"
        onRequestClose={handleCloseModal}
      >
        <div className="row discard-modal-header-wrapper">
          <div className="discard-modal-header">Reason for Discard </div>
          <img
            src={Cross}
            alt="Cancel"
            className="crossStyle"
            onClick={handleCloseModal}
          />
        </div>
        <div className="discard-modal-fonts">
          <div className="upload-files">
            {checkValue.map((value, index) => {
              return (
                <div key={index} className="discard-checkbox-container">
                  <Box
                    key={index}
                    label={value.label}
                    checked={value.isChecked}
                    Highlight={value.Highlight}
                    onChange={(val) =>
                      handleCheckBoxChange(val, value.id, value.label)
                    }
                  />
                </div>
              );
            })}
            <div className="placeholder">
              <textarea
                required
                type="text"
                maxLength="200"
                value={textvalue}
                className="discard-text-area"
                onChange={(e) => handleTextValueChange(e)}
              ></textarea>
              <div className="textarea-placeholder">
                Other reason<span> *</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-button-wrapper">
          <div
            onClick={handleCloseModal}
            className="cancel-button modal-buttons"
          >
            Cancel
          </div>
          <div
            onClick={() => {
              annotationName && setSelectedAnnotationUuid(null)
              handleDiscard(textvalue, selectedValue)
              annotationName && setTimeout(function() {
                setSelectedAnnotationUuid(annotationName)
              },0)
            } }
            disabled={
              selectedValue === "" ||
              (selectedValue === "None of the above" && textvalue === "")
            }
            className={
              selectedValue === "" ||
              (selectedValue === "None of the above" && textvalue === "")
                ? "div-disablebutton-criteria"
                : "confirm-button modal-buttons center"
            }
          >
            Submit
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DiscardReasonModal;